import API from '@/org-app/api';
import { createApiAction } from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  getMediaOwnerRevenueSplit: createApiAction(
    API.instance.postMediaOwnerRevenueSplit,
    types.UPDATE_REVENUESPLIT,
    'messages.failedToGetRevenueSplit',
  ),
};
